module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("海选作品提交：")]), _vm._v(" "), _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    ref: "uploadFileFirst",
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '24',
        objectTag: '01'
      },
      "before-upload": function (file, fileList) {
        _vm.beforeUpload(file, fileList, '01')
      },
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '01')
      },
      "file-list": _vm.designFirstFile,
      "auto-upload": true,
      "limit": 3,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.designFirstFile.length <= 0),
      expression: "designFirstFile.length<=0"
    }],
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.user.userType == '10' ? '请上传少于15页PDF作品文档' : '请上传压缩文件（内含6张参赛作品图片）'))])])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("复赛作品提交：")]), _vm._v(" "), _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    ref: "uploadFileSecond",
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '24',
        objectTag: '02'
      },
      "before-upload": function (file, fileList) {
        _vm.beforeUpload(file, fileList, '02')
      },
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '02')
      },
      "file-list": _vm.designSecondFile,
      "auto-upload": true,
      "limit": 3,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.designSecondFile.length <= 0),
      expression: "designSecondFile.length<=0"
    }],
    staticClass: "describe"
  }, [_vm._v(_vm._s(_vm.user.userType == '10' ? '请上传1分30秒以内的视频' : '请上传少于15页PDF作品文档'))])])], 1)])]), _vm._v(" "), (_vm.user.userType == '10') ? _c('p', {
    staticClass: "title"
  }, [_vm._v("决赛作品提交：")]) : _vm._e(), _vm._v(" "), (_vm.user.userType == '10') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    ref: "uploadFileThird",
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '24',
        objectTag: '03'
      },
      "before-upload": function (file, fileList) {
        _vm.beforeUpload(file, fileList, '03')
      },
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '03')
      },
      "file-list": _vm.designThirdFile,
      "auto-upload": true,
      "limit": 3,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.designThirdFile.length <= 0),
      expression: "designThirdFile.length<=0"
    }],
    staticClass: "describe"
  }, [_vm._v("请上传少于15页PPT")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showFlag) ? _c('div', {
    staticClass: "design-confirm-btn"
  }, [_c('y-button', {
    attrs: {
      "text": "立即提交",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.submitFile
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e3d29b3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Vision/matchUpload.vue
// module id = 679
// module chunks = 0